<template>
  <div class="meterial-input-page" >
    <a-row :gutter="13">
      <a-col :xl="leftColWidth"  :span="24"  >
        <depart-list   @chooseDepart="handleChooseDepart" ></depart-list>
      </a-col>
      <a-col :xl="rightColWidth" :span="24" v-show="choosedWorkshopId"  >
        <workshop-list   ref="refworkshop" @close="handleCloseWorkshop" ></workshop-list>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import DepartList from './components/DepartList.vue'
import WorkshopList from './components/WorkshopList.vue'

export default {
  data() {
    return {
      choosedWorkshopId:""
    }
  },
  methods: {
    handleChooseDepart(record){
      this.choosedWorkshopId=record.id
      let recordCopy=JSON.parse(JSON.stringify(record))
      recordCopy.departId=recordCopy.id;
      delete recordCopy.id;
      this.$nextTick(()=>{
        this.$refs.refworkshop.choosedDepart(recordCopy);
      })
    },
    handleCloseWorkshop(){
      this.choosedWorkshopId=''
    }
  },
  computed:{
    leftColWidth(){
      return this.choosedWorkshopId?10:24
    },
    rightColWidth(){
      return this.choosedWorkshopId?14:0
    }
  },
  components:{
    DepartList,WorkshopList
  }
}
</script>

<style lang="less" scoped>
.meterial-input-page{
  height: 100%;
}
</style>